import { Box, ButtonGroup, Link, PageHeader } from '@dagens/carrot';
import { useTranslation } from '@dagens/frontend-i18n';
import { Navigate, useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Illustrations } from '../../../utils/Illustrations';
import Container from '@carrot-deprecated/container';
import Typography from '@carrot-deprecated/typography';
import { Page } from '@components/page';
import { useMediaQuery } from '_common/hooks/useMediaQueries';

type LocationState =
  | {
      details: string;
    }
  | undefined;

const Illustration = styled.img`
  width: auto;
  height: auto;
  max-height: 318px;
  max-width: 240px;
  object-fit: contain;
`;

const DeliveryRouteRequestPageConfirmation = () => {
  const mediaQuery = useMediaQuery();
  const { t } = useTranslation();
  const location = useLocation();
  const state = location.state as LocationState;
  const { details } = state ?? {};

  if (!details) {
    return <Navigate to="/profile/delivery-route-request/start" />;
  }

  return (
    <Page
      header={
        <Box.FullWidth>
          <PageHeader
            title={t('producer:DeliveryRouteRequest.ConfirmationPageHeader')}
          />
        </Box.FullWidth>
      }
      // eslint-disable-next-line react/jsx-no-useless-fragment
      backButton={<></>}
    >
      <Container
        flex
        gap="m"
        justify="space-between"
        wrap="nowrap"
        direction={mediaQuery.mobileOnly ? 'column-reverse' : 'row'}
        mt="xl"
      >
        <Container>
          <Typography variant="paragraph" mb="m" color="secondary">
            {details}
          </Typography>
          <Typography variant="paragraph">
            {t('producer:DeliveryRouteRequest.SuccessText')}
          </Typography>
        </Container>
        <Container px="m">
          <Illustration
            src={Illustrations.BIKE_DELIVERY}
            alt={t('common:Illustration')}
          />
        </Container>
      </Container>

      <Container py="s">
        <ButtonGroup.Wrap>
          <Link to="/profile" variant="primary" size="regular">
            {t('producer:DeliveryRouteRequest.SeeActiveDeliveryRoutes')}
          </Link>
          <Link
            to="/profile/delivery-route-request/start"
            size="small"
            variant="borderless"
          >
            {t('producer:DeliveryRouteRequest.RequestAnotherDeliveryRoute')}
          </Link>
        </ButtonGroup.Wrap>
      </Container>
    </Page>
  );
};

export default DeliveryRouteRequestPageConfirmation;
